<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between mb-2">
      <div>
        <div class="section-title">Checklist Categories</div>
        <div class="section-subTitle my-2">
          Manage All your Checklist Categories here.
        </div>
      </div>

      <div class="d-flex align-items-center">
        <div>
          <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
          <!-- v-if="cinema_manager_add_edit_disabled != 3" -->
          <b-button
            variant="default"
            :to="{ name: 'Add Checklist Category' }"
            class="btn-blue"
            >{{ $t("add") }}</b-button
          >
        </div>
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container" style="margin-bottom:10px">
      <div class="desg-list-header" style="justify-content:normal">
        <div class="pr-4">{{ $tc("status", 2) }}</div>

        <div>
          <img
            v-if="this.columnName != 'cc_name'"
            @click="onSortValue('cc_name', 'asc')"
            src="@/assets/img/icons/updown.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          <img
            v-else-if="isSort && isAscending"
            @click="onSortValue('cc_name', 'asc')"
            src="@/assets/img/icons/asc.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          <img
            v-else
            @click="onSortValue('cc_name', 'desc')"
            src="@/assets/img/icons/desc.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          Category
        </div>
      </div>
      <ul class="desg-list" v-if="categoryList.length > 0">
        <li
          style="justify-content:normal"
          v-for="(category, categoryLoopKey) in categoryList"
          :key="categoryLoopKey"
          class="light_grey_back"
        >
          <div class="d-flex align-items-center">
            <!-- <label class="ios-switch">
              <input
                value="Y"
                v-model="category.cc_is_active"
                disabled
                type="checkbox"
                class="ios-checkbox"
              />
              <span class="switch-slider"></span>
            </label> -->
            <StatusDot
              :status="
                category.cc_is_active === 'Y'
                  ? 'active'
                  : category.cc_is_active === 'N' && 'inactive'
              "
            />
            <b-dropdown right variant="edit" class="ml-2">
              <b-dropdown-item
                :to="{
                  name: 'Edit Checklist Category',
                  params: { cc_id: category.checklist_category_id }
                }"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t("edit") }}
              </b-dropdown-item>
              <b-dropdown-item
                :to="{
                  name: 'View Checklist Category',
                  params: { cc_id: category.checklist_category_id }
                }"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t("view") }}
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="ml-4">{{ category.cc_name }}</div>
        </li>
      </ul>
      <div class="pb-3" v-else>
        <NoRecords classes="mb-0" />
      </div>
      <!-- <table>
        <tbody>
          <tr>
            <td colspan="2">
              <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div>
            </td>
          </tr>
        </tbody>
      </table>-->
    </div>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import ChecklistService from "@/services/ChecklistService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      categoryList: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: null,
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: ""
    };
  },
  mounted() {
    this.getCategoryList();
  },
  methods: {
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getCategoryList();
    },
    getCategoryList() {
      ChecklistService.GetCategories({
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.categoryList = data.Records;
            console.log("this.categoryList :>> ", this.categoryList);
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.categoryList = [];
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.categoryList = [];
          this.$toasted.show(error);
        });
    },
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCategoryList();
      } else {
        this.currentPage = event;
        this.getCategoryList();
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 4 },
        { name: "40", id: 5 },
        { name: "50", id: 6 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CheckListCategoriesComponents/checkListCategories.vue